import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const animationDefault = item =>
    gsap.from(item, {
        y: 10,
        opacity: 0,
        ease: 'power1.in',
        duration: 0.4,
        scrollTrigger: {
            trigger: item,
            start: 'top 75%',
            markers: true,
        },
        onStart: () => {
            console.log('onStart', { item });
        },
        onComplete: () => {
            console.log('onComplete', { item });
        },
    });

const animationWithStagger = ({ item, trigger }) =>
    gsap.from(item, {
        y: 10,
        opacity: 0,
        ease: 'power1.in',
        duration: 0.4,
        stagger: 0.15,
        scrollTrigger: {
            trigger: trigger,
            start: 'top 75%',
            markers: true,
        },
        onStart: () => {
            console.log('onStart', { item });
        },
        onComplete: () => {
            console.log('onComplete', { item });
        },
    });

export const useAnimation = ({ items, container, dependencies = [] }) => {
    console.log('useAnimation');
    useGSAP(
        () => {
            let targets = gsap.utils.toArray(items);
            targets.forEach(item => animationDefault(item));
        },
        { dependencies, scope: container, revertOnUpdate: true },
    );
};

export const useAnimationWithStagger = ({ item, container, trigger, dependencies = [] }) => {
    console.log('useAnimationWithStagger');
    useGSAP(
        () => {
            animationWithStagger({ item, trigger });
        },
        { dependencies, scope: container, revertOnUpdate: true },
    );
};
